
const ACTIVE_COLOR = '#B50006'
export {
  ACTIVE_COLOR
}

